import React from 'react';
import { useNavigate } from 'react-router';
import { setDoTutorial } from '../../store/globalStateSlice';
import { useAppDispatch } from '../../store/hooks';
import ConfirmPopup from '../molecules/ConfirmPopup';
import questionMarkIcon from '../../static/icons/icon_question_mark_white.svg';

const TopBarTutorialButton = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const [showDoTutorialDialog, setShowDoTutorialDialog] = React.useState<boolean>(false);

    const activateTutorial = () => {
        setShowDoTutorialDialog(false);
        dispatch(setDoTutorial(true));
        navigate('/');
    };

    return (<>
        <img className="icon-button" src={questionMarkIcon} onClick={() => setShowDoTutorialDialog(true)} />
        {showDoTutorialDialog && <ConfirmPopup 
            title="Anleitung"
            text="Möchtest Du die Anleitung noch einmal machen? Deine Daten gehen dabei nicht verloren."
            confirmLabel="Ja"
            dismissLabel="Nein"
            onConfirmClicked={activateTutorial}
            onDismissClicked={() => setShowDoTutorialDialog(false)}
        />}
    </>);
};

export default TopBarTutorialButton;
